import { useSearchParams } from "react-router-dom";
import useUserRoleFlags from "hooks/auth/useUserRoleFlags";
import useSelectedCropYearId, {
  CROP_YEAR_ID_QUERY_STRING_KEY,
} from "hooks/useSelectedCropYearId";
import dashboardPaths from "routes/dashboard/dashboardPaths";
import usersPaths from "routes/user/list/usersPaths";
import useSelectedFarmId, {
  FARM_ID_QUERY_STRING_KEY,
} from "./useSelectedFarmId";

export const useNavigationRoute = (): {
  usersRoute: string;
  dashboardRoute: string;
} => {
  const { isEmployee } = useUserRoleFlags();
  const [searchParams] = useSearchParams();
  const [farmId] = useSelectedFarmId();
  const [cropYearId] = useSelectedCropYearId();

  if (isEmployee) {
    return {
      usersRoute: `/${usersPaths.basePath}`,
      dashboardRoute: cropYearId
        ? `/${dashboardPaths.basePath}?${CROP_YEAR_ID_QUERY_STRING_KEY}=${cropYearId}`
        : `/${dashboardPaths.basePath}`,
    };
  } else {
    return {
      dashboardRoute: cropYearId
        ? `/${dashboardPaths.basePath}?${FARM_ID_QUERY_STRING_KEY}=${farmId}&${CROP_YEAR_ID_QUERY_STRING_KEY}=${cropYearId}`
        : `/${dashboardPaths.basePath}?${FARM_ID_QUERY_STRING_KEY}=${farmId}`,
      usersRoute: `/${usersPaths.basePath}?${searchParams}`,
    };
  }
};
